var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 54,
    viewBox: "0 0 48 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3868 47.8414H2.54212C2.04545 47.8414 1.64282 48.2433 1.64282 48.7391V51.036C1.64282 51.5318 2.04545 51.9338 2.54212 51.9338H45.3868C45.8835 51.9338 46.2861 51.5318 46.2861 51.036V48.7391C46.2861 48.2433 45.8835 47.8414 45.3868 47.8414Z",
    stroke: "#002458",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07739 26.9497V47.8403H16.3186H30.8963H42.1825V26.9497",
    stroke: "#002458",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1827 35.99V26.9497",
    stroke: "#002458",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8512 27.1523H43.1822C42.5443 27.1544 41.9304 26.9094 41.4697 26.4688L23.638 8.91375L5.78465 26.4688C5.57792 26.6654 5.33982 26.8262 5.08013 26.9447C4.76228 27.083 4.41903 27.1537 4.07227 27.1523C3.60999 27.1654 3.15411 27.042 2.76175 26.7976C2.36939 26.5532 2.058 26.1987 1.86659 25.7784C1.67518 25.3581 1.61226 24.8908 1.68571 24.435C1.75917 23.9791 1.96574 23.5551 2.27953 23.216L22.3449 2.49988C22.5107 2.32292 22.7109 2.18149 22.9332 2.08418C23.1554 1.98687 23.3952 1.93572 23.6379 1.93383C23.8807 1.93195 24.1212 1.97937 24.345 2.07322C24.5688 2.16707 24.7711 2.30537 24.9396 2.47973L45.626 23.1814C45.9468 23.5192 46.1599 23.9444 46.2385 24.4032C46.3172 24.862 46.2577 25.3338 46.0677 25.7589C45.8777 26.1839 45.5657 26.5432 45.1712 26.7912C44.7766 27.0392 44.3173 27.1649 43.8512 27.1523Z",
    stroke: "#002458",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3817 47.3036V34.7396H19.9913V47.3036H28.3817Z",
    stroke: "#002458",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0096 27.4062C26.2285 27.4062 28.0273 25.6106 28.0273 23.3955C28.0273 21.1804 26.2285 19.3848 24.0096 19.3848C21.7907 19.3848 19.9919 21.1804 19.9919 23.3955C19.9919 25.6106 21.7907 27.4062 24.0096 27.4062Z",
    stroke: "#002458",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.c922a21a251fd9960df46ea634e25776.svg";
export { ForwardRef as ReactComponent };